import servicesUtils from "../../../utils/servicesUtils";
import { GetCountsResponse } from "../types";

const getCounts = (apiParams = {}): Promise<number> => {
  return new Promise((resolve, reject) => {
    servicesUtils
      .postService<GetCountsResponse>("/patients/counts/", apiParams)
      .then((data) => {
        resolve(data.data.count);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getCounts;
